// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38ad2b02","453":"6ae60ec4","732":"680e85ff","977":"68143eac"}[chunkId] + ".chunk.js";
};